import { CurrencyCode, ProductPricingModel } from '@portals/types';

import { formatPrice } from './numbers';

export function getPricingModelDisplayName(pricingModel: ProductPricingModel) {
  switch (pricingModel) {
    case ProductPricingModel.Standard:
      return 'Standard';
    case ProductPricingModel.UsageBased:
      return 'Usage based';
    case ProductPricingModel.Personalized:
      return 'Personalized';
  }
}

export function getProductPriceDisplayText(params: {
  pricingModel: ProductPricingModel;
  usageBasedPriceInScu: number | null | undefined;
  usageBasedUnitName: string | null;
  amountInScu: number;
  paymentInterval: string;
  currency: CurrencyCode;
}) {
  if (params.pricingModel === ProductPricingModel.UsageBased) {
    return `${formatPrice({
      value: params.usageBasedPriceInScu,
      currencyCode: params.currency,
    })} / ${params.usageBasedUnitName}`;
  }

  let paymentIntervalText = '';

  if (params.paymentInterval === 'monthly') {
    paymentIntervalText = ' / month';
  } else if (params.paymentInterval === 'yearly') {
    paymentIntervalText = ' / year';
  }

  const priceText = formatPrice({
    value: params.amountInScu,
    currencyCode: params.currency,
  });

  return `${priceText}${paymentIntervalText}`;
}
